<div
  id="shipment-location-table-container"
  class="matp-table-container tw-max-h-full"
>
  <div class="matp-table-actions-area">
    <div class="matp-table-actions tw-flex tw-items-center tw-gap-2">
      <button
        mat-raised-button
        id="export-btn"
        class="tw-mr-2 !tw-w-[268px] tw-whitespace-nowrap"
        color="primary"
        (click)="onExportCsv()"
        style="position: absolute; right: 8px; top: -40px"
      >
        <mat-icon>Download</mat-icon>
        CSVエクスポート（BOM付）
      </button>
      <button
        mat-raised-button
        id="filter-clear-btn"
        class="tw-mr-2"
        (click)="clearFilters()"
      >
        <mat-icon>restart_alt</mat-icon>
        <span>クリア</span>
      </button>
      <button
        mat-raised-button
        id="add-btn"
        class="tw-mr-2 !tw-w-[126px]"
        color="primary"
        [matMenuTriggerFor]="createMenu"
      >
        <mat-icon>add</mat-icon>
        <span>新規登録</span>
      </button>
      <mat-menu #createMenu="matMenu">
        <button mat-menu-item (click)="imported.emit()">
          <span>インポート</span>
        </button>
        <button mat-menu-item (click)="created.emit()">
          <span>一件登録</span>
        </button>
      </mat-menu>
      <button
        mat-raised-button
        id="delete-all-btn"
        color="warn"
        class="tw-mr-2 !tw-w-[126px]"
        (click)="bulkDelete()"
        [disabled]="isBulkDeleteButtonDisable"
      >
        <mat-icon>delete</mat-icon>
        <span>一括削除</span>
      </button>
    </div>
  </div>

  <div class="matp-table-area">
    <table
      id="shipment-location-table"
      class="matp-table"
      mat-table
      matSort
      [matSortActive]="initSortState.active"
      [matSortDirection]="initSortState.direction"
      [dataSource]="dataSource"
    >
      <ng-container matColumnDef="checkbox">
        <th mat-header-cell *matHeaderCellDef class="matp-table-header-middle !tw-min-w-min">
          <mat-checkbox
            name="selectAll"
            color="primary"
            (change)="$event ? toggleAllRows() : null; updateBulkDeleteButtonState()"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          ></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox
            name="select"
            color="primary"
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(element) : null; updateBulkDeleteButtonState()"
            [checked]="selection.isSelected(element)"
          ></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="locationName">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">位置情報名</div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="locationName"
              type="text"
              [(ngModel)]="locationNameKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="locationname-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearLocationNameFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.locationName }}
        </td>
      </ng-container>
      <!-- 住所 -->
      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">住所</div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="address"
              type="text"
              [(ngModel)]="addressKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="address-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearAddressFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.address }}
        </td>
      </ng-container>
      <!-- 郵便番号 -->
      <ng-container matColumnDef="postalCode">
        <th mat-header-cell *matHeaderCellDef class="!tw-w-24">
          <div mat-sort-header class="matp-table-header-title">郵便番号</div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="postalCode"
              type="text"
              [(ngModel)]="postalCodeKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="postalcode-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearPostalCodeFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.postalCode | postalCode }}
        </td>
      </ng-container>
      <!-- ジオフェンス -->
      <ng-container matColumnDef="geofence">
        <th mat-header-cell *matHeaderCellDef>
          <div class="matp-table-header-title">ジオフェンス</div>
        </th>
        <td mat-cell *matCellDef="let element">
          @if (element.geofence?.geofenceType === "circle") {
            <div>円形</div>
            <div>
              <span>半径{{ element.geofence.circleRadius }}</span>
              <span>{{ element.geofence.circleRadiusUnit }}</span>
            </div>
          } @else if (element.geofence?.geofenceType === "polygon") {
            <div>フリー描画</div>
            <div>{{ element.geofence.polygonList.length - 1 }} 頂点</div>
          }
        </td>
      </ng-container>
      <!-- 操作 -->
      <ng-container matColumnDef="operation">
        <th mat-header-cell *matHeaderCellDef class="!tw-min-w-32 tw-max-w-32">
          <div class="matp-table-header-title">操作</div>
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-min-w-32">
          <div class="tw-flex tw-justify-center">
            <button
              mat-stroked-button
              id="edit-btn"
              color="primary"
              (click)="updated.emit(element); $event.stopPropagation()"
            >
              <mat-icon>edit</mat-icon>
              <span>編集</span>
            </button>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (mouseenter)="onMouseEnter($event)"
        (mouseleave)="onMouseLeave($event)"
        (click)="selectLocation(row)"
        [ngClass]="{
          '!tw-bg-black/[.04]': selectedRow?.locationId === row.locationId,
        }"
      ></tr>
    </table>
  </div>

  <mat-paginator
    id="shipment-location-table-paginator"
    [length]="dataSource.filteredData.length"
    [pageSize]="10"
    hidePageSize
    showFirstLastButtons
  ></mat-paginator>
</div>
